import { get } from "./baseService";

export async function getDomains() {
  const response = await get("domains", true);
  return response;
}

export async function getDomain(code) {
  const response = await get(`domains/${code}`, true);
  return response;
}

export async function getDomainSubs(code) {
  const response = await get(`domains/${code}/sub-domains`, true);
  return response;
}
